import React, { useContext, useEffect, useState } from 'react';
import { Dialog, DialogTitle, DialogContent, Typography, Box, IconButton, Divider, Grid } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { obtenerMuestroTarifaTipoHab } from '../../services/motorService';
import RoomTypeRatePlanContext from '../contexts/RoomTypeRatePlanContext';

const DialogRateDetail = ({ open, handleClose, rateDetail }) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [nightlyRates, setNightlyRates] = useState([]);
  const [coin, setCoin] = useState('');
  const { cartItems, setCartItems } = useContext(RoomTypeRatePlanContext);
  useEffect(() => {
    console.log("Detalle de lo del carrito", rateDetail);
    if (rateDetail && rateDetail.length > 0) {
      const selectedRange = {
        startDate: rateDetail[0].CarritoItemDesde,
        endDate: rateDetail[0].CarritoItemHasta,
      };
      const tarifaTipoHab = rateDetail[0].CarritoItemTipoHab;
      if(cartItems && cartItems.length > 0){
        const moneda = cartItems[0].CarritoItemMoneda;
        setCoin(moneda);
      }
      /*const moneda = rateDetail[0].CarritoItemMoneda;
      console.log(moneda);
      setCoin(moneda);*/
      fetchNightlyRates(tarifaTipoHab, selectedRange);
    }
  }, [rateDetail]);


  const fetchNightlyRates = async (tipoHab, selectedRange) => {
    try {
      const startDate = new Date(selectedRange.startDate);
      const endDate = new Date(selectedRange.endDate);

      const nightlyRates = [];

      let currentDate = new Date(startDate);
      let index = 0;
      while (currentDate <= endDate) {
        const formattedDate = currentDate.toISOString().split('T')[0];
        let rate = 0;
        if(index < rateDetail.length){
          rate = rateDetail[index].CarritoItemTotal;
          nightlyRates.push({ date: formattedDate, rate });
        }
        currentDate.setDate(currentDate.getDate() + 1);
        index++;
      }

      setNightlyRates(nightlyRates);
    } catch (error) {
      console.error('Error fetching nightly rates:', error);
    }
  };

  const formatDate = (date) => {
    const parsedDate = new Date(date);
    const day = parsedDate.getUTCDate();
    const month = parsedDate.getUTCMonth() + 1;
    const year = parsedDate.getUTCFullYear();
    return `${day.toString().padStart(2, '0')}/${month.toString().padStart(2, '0')}/${year}`;
  };

  const totalAmount = nightlyRates.reduce((total, rate) => total + parseFloat(rate.rate), 0).toFixed(2);

  return (
    <Dialog
      fullScreen={fullScreen}
      open={open}
      onClose={handleClose}
      aria-labelledby="responsive-dialog-title"
      maxWidth="lg"
      fullWidth={!fullScreen}
      sx={{
        '& .MuiDialog-paper': {
          width: '100%',
          maxWidth: fullScreen ? '100%' : '900px',
        },
      }}
    >
      <DialogTitle id="responsive-dialog-title">
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {rateDetail && rateDetail.length > 0 ? rateDetail[0].CarritoItemTarifa : 'Detalle de la tarifa'}
          <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContent>
          <Typography variant="body1" gutterBottom sx={{ fontWeight: 'bold' }}>
            Desglose de tarifas para las noches del {formatDate(nightlyRates[0]?.date)} al {formatDate(nightlyRates[nightlyRates.length-1]?.date)}
          </Typography>
          {nightlyRates && nightlyRates.length > 0 ? (
            <>
              {nightlyRates.map((rateDetails, index) => (
                <Grid container key={index}>
                  <Grid item xs={6}>
                    <Typography variant="body2" color="textSecondary">
                      {formatDate(rateDetails.date)}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" sx={{ textAlign: 'right' }}>
                      {`${coin} ${parseFloat(rateDetails.rate).toFixed(2)}`}
                    </Typography>
                  </Grid>
                </Grid>
              ))}
              <Divider sx={{ my: 2 }} />
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0' }}>
                <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                  Total
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 'bold', textAlign: 'right' }}>
                  {`${coin} ${totalAmount}`}
                </Typography>
              </Box>
            </>
          ) : (
            <Typography variant="body2" color="textSecondary">
              No hay detalles disponibles para mostrar.
            </Typography>
          )}
        </DialogContent>
      </DialogContent>
    </Dialog>
  );
};

export default DialogRateDetail;
